/* 87C custom — cf snippets/_87c-customs-index.liquid */
/* ============================================================================
   87C Mobile Menu Enhancement
   ----------------------------------------------------------------------------
   Works ON TOP of the original Reformation mobile menu (no Liquid replacement).

   Features:
   1. Flattens L3 submenus into L2 with section headers
   2. Injects featured products PER SUBMENU (dynamic, from the submenu's collection)
   3. Injects a global "Nouveautes" grid at the root level
   4. Preserves existing mega menu promo blocks from desktop config

   All content is DYNAMIC — tied to the desktop menu structure.
   ============================================================================ */

(function() {
	'use strict';

	function init() {
		var menu = document.getElementById('mobile-menu');
		if (!menu) return;

		/* S64 2026-05-18 HOTFIX : flattenL3Menus disabled — li.remove() (was line 64)
		   was destroying L2 collection parents that have L3 children. Default
		   Reformation cascading accordion behaviour restored. See
		   research/MENU-BURGER-HOTFIX-S64-2026-05-18.md for full analysis. */
		// flattenL3Menus(menu);

		/* injectRootProducts removed — now rendered server-side via Liquid
		   (configurable in Theme Editor → Header → Mobile menu → Featured products collection) */
	}

	/* ========================================================================
	   1. Flatten L3 into L2 with section headers
	   ======================================================================== */
	function flattenL3Menus(menu) {
		var l2Menus = menu.querySelectorAll('ul.sub-menu');

		l2Menus.forEach(function(l2) {
			var l3Details = l2.querySelectorAll(':scope > li > details');

			l3Details.forEach(function(details) {
				var li = details.parentElement;
				var summary = details.querySelector('summary');
				var l3List = details.querySelector('ul.sub-menu, ul');
				if (!summary || !l3List) return;

				var headerLi = document.createElement('li');
				headerLi.className = 'c87-menu-section-header';
				var headerSpan = document.createElement('span');
				var titleText = summary.childNodes[0]
					? summary.childNodes[0].textContent.trim()
					: summary.textContent.trim();
				headerSpan.textContent = titleText;
				headerLi.appendChild(headerSpan);

				var fragment = document.createDocumentFragment();
				fragment.appendChild(headerLi);

				var l3Items = l3List.querySelectorAll(':scope > li');
				l3Items.forEach(function(item) {
					if (item.classList.contains('parent-link-back')) return;
					var clone = item.cloneNode(true);
					var link = clone.querySelector('a');
					if (link) link.classList.add('c87-menu-link--sub');
					fragment.appendChild(clone);
				});

				li.parentElement.insertBefore(fragment, li);
				li.remove();
			});
		});
	}

	/* ========================================================================
	   2. Submenu products — REMOVED.
	   Promo/featured blocks inside submenus are handled by desktop mega menu
	   blocks (configured in Theme Editor → Header → Mega menu blocks).
	   Product grids only appear at the root level (see injectRootProducts).
	   ======================================================================== */

	/* ========================================================================
	   3. Inject root-level "Nouveautes" products (global, mobile-only)
	   ======================================================================== */
	function injectRootProducts(menu) {
		var footer = menu.querySelector('.thb-mobile-menu-footer');
		if (!footer) return;

		// Find "nouveautes" collection from the menu links
		var collectionHandle = null;
		var collectionTitle = 'Nouveautés';
		var allLinks = menu.querySelectorAll('ul.mobile-menu a[href*="/collections/"]');

		allLinks.forEach(function(link) {
			var h = link.getAttribute('href');
			if (h && (h.indexOf('nouveaut') !== -1 || h.indexOf('new-') !== -1)) {
				var m = h.match(/\/collections\/([^/?#]+)/);
				if (m) collectionHandle = m[1];
			}
		});

		// Fallback to first collection if no "nouveautes" found
		if (!collectionHandle && allLinks.length > 0) {
			var m = allLinks[0].getAttribute('href').match(/\/collections\/([^/?#]+)/);
			if (m) {
				collectionHandle = m[1];
				collectionTitle = allLinks[0].textContent.trim() || 'Sélection';
			}
		}

		if (!collectionHandle) return;

		fetchProducts(collectionHandle, function(products) {
			if (!products || products.length === 0) return;
			var section = buildProductGrid(products, collectionTitle, 'large');
			footer.parentElement.insertBefore(section, footer);
		});
	}

	/* ========================================================================
	   Shared: Fetch products via AJAX
	   ======================================================================== */
	function fetchProducts(handle, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', '/collections/' + handle + '/products.json?limit=4', true);
		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					try {
						var data = JSON.parse(xhr.responseText);
						var filtered = data.products.filter(function(p) {
							return !p.tags || p.tags.indexOf('exclu') === -1;
						});
						callback(filtered.slice(0, 4));
					} catch(e) { callback(null); }
				} else { callback(null); }
			}
		};
		xhr.send();
	}

	/* ========================================================================
	   Shared: Build a product grid section
	   size: 'large' (4 cols, root level) or 'small' (2 cols, inside submenu)
	   ======================================================================== */
	function buildProductGrid(products, title, size) {
		var section = document.createElement('li');
		section.className = 'c87-menu-products c87-menu-products--' + size;

		if (title) {
			var heading = document.createElement('p');
			heading.className = 'c87-menu-products__title';
			heading.textContent = title;
			section.appendChild(heading);
		}

		var grid = document.createElement('div');
		grid.className = 'c87-menu-products__grid';

		products.forEach(function(product) {
			var link = document.createElement('a');
			link.href = '/products/' + product.handle;
			link.className = 'c87-menu-products__item';

			if (product.images && product.images.length > 0) {
				var img = document.createElement('img');
				var imgSize = size === 'large' ? '200x' : '150x';
				img.src = product.images[0].src.replace(/\.([^.]+)$/, '_' + imgSize + '.$1');
				img.alt = product.title;
				img.loading = 'lazy';
				img.width = size === 'large' ? 100 : 75;
				img.height = size === 'large' ? 133 : 100;
				link.appendChild(img);
			}

			var span = document.createElement('span');
			span.textContent = product.title;
			link.appendChild(span);

			grid.appendChild(link);
		});

		section.appendChild(grid);
		return section;
	}

	// Run on DOMContentLoaded
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
